import { Image, Icon } from 'semantic-ui-react';

/**
 * `<Image avatar src="">` resolves to the current page URL and renders a broken-image icon —
 * which is exactly what a deleted (anonymised) account's poster looks like, since its
 * `photoUrl` is always blank. Falls back to a plain placeholder icon instead.
 */
export const PosterAvatar = ({
  photoUrl,
  className,
  size,
}: {
  photoUrl?: string | null;
  className?: string;
  size?: number;
}) => {
  if (photoUrl) {
    return <Image avatar src={photoUrl} className={className} />;
  }

  const dimension = size ?? 32;

  return (
    <Icon
      name="user circle"
      className={className}
      style={{
        color: '#c7c7c7',
        background: '#f2f2f2',
        borderRadius: '50%',
        margin: 0,
        width: dimension,
        height: dimension,
        fontSize: dimension,
        lineHeight: 1,
      }}
    />
  );
};
